import React from "react";
import {
  Box,
  Container,
  Typography,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import BgTitle from "components/title/BgTitle";
import { useTranslation } from "react-i18next";

// Styled components
const StyledListItem = styled(ListItem)(({ theme }) => ({
  borderLeft: `4px solid ${theme.palette.primary.main}`,
  marginBottom: theme.spacing(2),
  backgroundColor: "#f5f5f5",
  borderRadius: theme.spacing(1),
}));

const SuppliersComponent = () => {
  const { t } = useTranslation();
  const salesLeasePosts = t("suppliers.popular_posts", { returnObjects: true });
  const recentPosts = t("suppliers.recent_posts", { returnObjects: true });

  return (
    <Container maxWidth="lg">
      <Box sx={{ py: 4 }}>
        <BgTitle text={t("suppliers.title")} isCenter={true} />
        <Box>
          {/* Popular Posts Section */}
          <Typography variant="h6" sx={{ mb: 3, mt: 2 }}>
            {t("suppliers.sales_and_lease_heading")}
          </Typography>
          <List>
            {salesLeasePosts.map((post, index) => (
              <StyledListItem key={index}>
                <ListItemText
                  primary={post.title}
                  sx={{
                    "& .MuiListItemText-primary": {
                      fontSize: "0.875rem",
                      fontWeight: 500,
                    },
                  }}
                />
              </StyledListItem>
            ))}
          </List>

          {/* Recent Posts Section */}
          <Typography variant="h6" sx={{ mb: 1, mt: 1 }}>
            {t("suppliers.ses_heading")}
          </Typography>
          <List>
            {recentPosts.map((post, index) => (
              <StyledListItem key={index}>
                <ListItemText
                  primary={post}
                  sx={{
                    "& .MuiListItemText-primary": {
                      fontSize: "0.875rem",
                      fontWeight: 500,
                    },
                  }}
                />
              </StyledListItem>
            ))}
          </List>
        </Box>
      </Box>
    </Container>
  );
};

export default SuppliersComponent;
